import {
  mapperModuleInternalVideo,
  mapperModuleMedia,
  mapperModuleVideo
} from '../../../../core/data-layer/modules/mappers'
import imageSizes from '../../../../core/constants/imageSizes'
import { mapperGlobalDataTheme } from '../../../../core/data-layer/global-data/mappers'
import type { MapperImageOptions, MapperOptions } from '#layers/core/types'

const mapMedia = (item: any, imageOptions: MapperImageOptions) => {
  const contentType = item?.contentType || 'ModuleMedia'

  switch (contentType) {
    case 'ModuleMedia': {
      return { image: mapperModuleMedia(item, imageOptions) }
    }
    case 'ModuleVideo': {
      return { video: mapperModuleVideo(item, imageOptions) }
    }
    case 'ModuleInternalVideo': {
      return { video: mapperModuleInternalVideo(item, imageOptions) }
    }
    default: {
      return {}
    }
  }
}

export const mapperBlockCampaignsMedia = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const fallBackImageSizes = imageSizes.columns12_5269

  const fallbackImageOptions = {
    lazy: true,
    sizes: fallBackImageSizes
  }

  return {
    contentType: data.contentType || '',
    id: data.sys?.id || '',
    sys: data.sys || null,
    title: data.title || '',
    description: data.blockCampaignsMediaDescription || '',
    ...mapMedia(data.media, options.imageOptions || fallbackImageOptions),
    theme: mapperGlobalDataTheme(data.sectionTheme)?.theme || null
  }
}
